<template>
  <page-main
    :tableData="tableData"
    :loading="loading"
    :tablePage="page"
    :disabled="disabled"
    @reload="getData"
  >
    <pagination
      size="small"
      align="right"
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </page-main>
</template>
<script>
import PageMain from './main'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageMain,
  },
  mixins: [BaseTable],
  props: {
    planOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
    }
  },
  activated() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .planOrderDetailListApi({
          planOrderCode: this.planOrderCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
